import { Package, BasketItem } from '../../../types/basket';
import { isMainItem } from '../../organisms/Basket/groupItems';

type SummaryBadgeInfo = {
  deliveries: number;
  quantity: number;
  reduction: number;
};

const getReduction = (discount: number, item: BasketItem) => discount + item.discount.total; // TODO No price calculations in FE
const getQuantity = (itemsQuantity: number, item: BasketItem) =>
  isMainItem(item) ? itemsQuantity + item.quantity : itemsQuantity;
const getBasketSummaryBadgeInfo = (packages: Package[]): SummaryBadgeInfo =>
  packages
    .filter(({ isAvailable }) => isAvailable)
    .reduce<SummaryBadgeInfo>(
      (info, pkg) => ({
        deliveries: pkg.items.length ? info.deliveries + 1 : info.deliveries,
        quantity: info.quantity + pkg.items.reduce(getQuantity, 0),
        reduction: info.reduction + pkg.items.reduce(getReduction, 0)
      }),
      {
        deliveries: 0,
        quantity: 0,
        reduction: 0
      }
    );

export default getBasketSummaryBadgeInfo;
